<div fxFill fxLayout="column" class="table-list">
        <h1>{{title}} <filters-component id="filters"></filters-component> <columns-component id="columns"></columns-component> <save-view id="save-view"></save-view> <span id="pre"><button [disabled]="assignmentService.deleting === true" *ngIf="selectedRows.length > 0" class="mat-flat-button" (click)="assignmentService.delete(selectedRows)"><mat-icon>delete</mat-icon> Delete Selected <ng-container *ngIf="selectedRows.length > 0">({{selectedRows.length}})</ng-container> <img class="loader" *ngIf="assignmentService.deleting === true" src="/wp-content/themes/swarm/app/assets/images/loading.gif" /></button></span></h1> 
        <div>
        <mat-table #table [dataSource]="service.assignments" [ngClass]="{deletable: canDelete}">

        <!-- delete -->
        <ng-container matColumnDef="pre">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let item"> 
                    <mat-checkbox 
                        [disabled]="assignmentService.deleting === true" 
                        [checked]="inSelectedRows(item)" 
                        (change)="selectRowChange($event, item, false)">
                    </mat-checkbox> 
                    <button 
                        [disabled]="assignmentService.deleting === true"
                        (click)="selectRowChange({checked: true}, item, true)" 
                        class="faded">
                        <mat-icon>delete</mat-icon>
                    </button> 
                </mat-cell>
            </ng-container>

            <!-- id -->
            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef> Assignment ID </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.id}} </mat-cell>
            </ng-container>

            <!-- abbreviation -->
            <ng-container matColumnDef="abbreviation">
                <mat-header-cell *matHeaderCellDef> Abbr. </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.abbreviation}} </mat-cell>
            </ng-container>

            <!-- pageAddDate -->
            <ng-container matColumnDef="pageAddDate">
                <mat-header-cell *matHeaderCellDef> Additions Due </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.pageAddDate | date:'LLL d'}} </mat-cell>
            </ng-container>

            <!-- pageAddWriter -->
            <ng-container matColumnDef="pageAddWriter">
                <mat-header-cell *matHeaderCellDef> Additions Writer </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <page-add-writer-component
                        [listOnly]="true"
                        [team]="item.team">
                    </page-add-writer-component>
                </mat-cell>
            </ng-container>

            <!-- title -->
            <ng-container matColumnDef="title" style="flex: 0 0 300px;">
                <mat-header-cell *matHeaderCellDef> Assignment Title </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="item.title"> {{item.title}} </mat-cell>
            </ng-container>

            <!-- articleTitle -->
            <ng-container matColumnDef="articleTitle" style="flex: 0 0 300px;">
                <mat-header-cell *matHeaderCellDef> Article Title </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="item.articleTitle"> {{item.articleTitle}} </mat-cell>
            </ng-container>

            <!-- targetPublishDate -->
            <ng-container matColumnDef="targetPublishDate">
                <mat-header-cell *matHeaderCellDef> Target Publish Date </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.date | date:'short'}} </mat-cell>
            </ng-container>

            <!-- publishDate -->
            <ng-container matColumnDef="publishDate">
                <mat-header-cell *matHeaderCellDef> Date Published </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.date | date:'LLL d'}} </mat-cell>
            </ng-container>

            <!-- dueDate -->
            <ng-container matColumnDef="dueDate">
                <mat-header-cell *matHeaderCellDef> Due </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.dueDate | date:'LLL d'}} </mat-cell>
            </ng-container>

            <!-- lastReviewDate -->
            <ng-container matColumnDef="lastReviewDate">
                <mat-header-cell *matHeaderCellDef> Last Reviewed </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.lastReviewDate | date:'LLL d'}} </mat-cell>
            </ng-container>

            <!-- childType -->
            <ng-container matColumnDef="childType">
                <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.childType | titlecase}} </mat-cell>
            </ng-container>

            <!-- editor -->
            <ng-container matColumnDef="editor">
                <mat-header-cell *matHeaderCellDef> Editor </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <page-add-writer-component
                        [listOnly]="true"
                        [team]="item.team"
                        [role]="'editor'">
                    </page-add-writer-component>
                </mat-cell>
            </ng-container>

            <!-- priority -->
            <ng-container matColumnDef="priority">
                <mat-header-cell *matHeaderCellDef> Priority </mat-header-cell>
                <mat-cell *matCellDef="let item"> 
                    <priority-component [value]="item.priority" [listOnly]="true"></priority-component>
                </mat-cell>
            </ng-container>

            <!-- properties -->
            <ng-container matColumnDef="sites">
                <mat-header-cell *matHeaderCellDef> Properties </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <sites-component 
                        [(sites)]="item.sites">
                    </sites-component>
                </mat-cell>
            </ng-container>

            <!-- quizType -->
            <ng-container matColumnDef="quizType">
                <mat-header-cell *matHeaderCellDef> Quiz Type </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{ getQuizType(item) }} </mat-cell>
            </ng-container>

            <!-- reference -->
            <ng-container matColumnDef="reference">
                <mat-header-cell *matHeaderCellDef> Reference </mat-header-cell>
                <mat-cell *matCellDef="let item"> {{item.reference}} </mat-cell>
            </ng-container>

            <!-- status -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
                <mat-cell *matCellDef="let item"> <button mat-flat-button color="{{item.status}}">{{item.status | status: item.cloneMaster}}</button> </mat-cell>
            </ng-container>

            <!-- taxonomies -->
            <ng-container matColumnDef="taxonomies">
                <mat-header-cell *matHeaderCellDef> Taxonomy </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="getTaxTitle(item.taxonomies)"> 
                    <taxonomies-component [taxonomies]="item.taxonomies"></taxonomies-component> 
                </mat-cell>
            </ng-container>

            <!-- creator taxonomies -->
            <ng-container matColumnDef="taxonomySearch">
                <mat-header-cell *matHeaderCellDef> Creator </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="getCreatorTaxonomies(item).join('&#013;')">
                    <div class="chips">
                        <span 
                            class="chip" 
                            *ngFor="let taxonomy of getCreatorTaxonomies(item)">
                            {{taxonomy}}
                        </span>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- site-siteCategorySearch -->
            <ng-container matColumnDef="siteCategorySearch">
                <mat-header-cell *matHeaderCellDef> Site Categories </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="getSiteCategories(item).join('&#013;')">
                    <div class="chips">
                        <span 
                            class="chip" 
                            *ngFor="let site of getSiteCategories(item)">
                            {{site}}
                        </span>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- terms -->
            <ng-container *ngFor="let slug of taxSlugs" matColumnDef="{{slug}}">
                <mat-header-cell *matHeaderCellDef> {{taxOptions[slug].name}} </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="getTerms(item, slug)"> 
                    <div class="chips">
                        <span 
                            class="chip" 
                            *ngFor="let term of item.taxonomies[slug]">
                            {{term.name}}
                        </span>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- team -->
            <ng-container matColumnDef="team">
                <mat-header-cell *matHeaderCellDef> Team </mat-header-cell>
                <mat-cell *matCellDef="let item"> 
                    <team-component 
                        [team]="item.team"
                        [listOnly]="true">
                    </team-component>
                </mat-cell>
            </ng-container>

            <!-- writer -->
            <ng-container matColumnDef="writer">
                <mat-header-cell *matHeaderCellDef> Writer </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <page-add-writer-component
                        [listOnly]="true"
                        [team]="item.team"
                        [role]="'writer'">
                    </page-add-writer-component>
                </mat-cell>
            </ng-container>

            <!-- affiliates -->
            <ng-container matColumnDef="affiliates">
                <mat-header-cell *matHeaderCellDef> Affiliates </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="getAffiliates(item).join(', ')">
                    <div class="chips">
                        <span 
                            class="chip" 
                            *ngFor="let affiliate of ( getAffiliates(item) )">
                            {{affiliate}}
                        </span>
                    </div> 
                </mat-cell>
            </ng-container>

            <!-- lock -->
            <ng-container matColumnDef="lock">
                <mat-header-cell *matHeaderCellDef> Busy Bee </mat-header-cell>
                <mat-cell *matCellDef="let item" [attr.title]="service.getLockText(item.lock)"> {{ service.getLockText(item.lock) }} </mat-cell>
            </ng-container>

            <!-- actions -->
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                <mat-cell class="button-cell" *matCellDef="let item">
                    <a class="button" [ngClass]="{'disabled': service.maybeLocked(item.lock)}" [routerLink]="['/slideshow', item.id]">View</a>
                    <a *ngIf="item.status == 'ready_to_delete_an' && route.snapshot.data.state == 'readyToDeleteAppleNews'" class="button" [ngClass]="{'disabled': service.maybeLocked(item.lock)}" (click)="submitAssignment(item)">Submit</a>
                    <a *ngIf="item.status == 'ready_to_repost' && route.snapshot.data.state == 'readyToRepost'" class="button" [ngClass]="{'disabled': service.maybeLocked(item.lock)}" (click)="unSubmitAssignment(item)">Return</a>
                    <a *ngIf="item.status == 'ready_to_delete_an' && route.snapshot.data.state == 'readyToDeleteAppleNews'" class="button" [ngClass]="{'disabled': service.maybeLocked(item.lock)}" (click)="retireAssignment(item)">Retire</a>
                    <a *ngIf="item.status == 'syndication_retired'" class="button" [ngClass]="{'disabled': service.maybeLocked(item.lock)}" (click)="unretireAssignment(item)">Unretire</a>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="fs.columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: fs.columns" [ngClass]="{active: inSelectedRows(row)}"></mat-row>
        </mat-table>
        <mat-paginator #paginator [pageSizeOptions]="[15, 25, 50, 100]" [length]="service.foundPosts" [pageSize]="service.pageSize" (page)="pageChange($event)"></mat-paginator>
    </div>
</div>